import { useState, useEffect } from "react";
import styles from "./reviews.module.css";
import {
  Button,
  HeadingTitle,
  SubHeadingTitle,
  Loader,
  Ratings,
  Image,
  Pagination,
} from "../../../../components/shared/index";
import { useProductReviewsQuery } from "../../../../queries/useReviewQuery";
import { useNavigate } from "react-router-dom";

const ReviewTabs = ({ productId, productDescription, loggedInUserId }) => {
  const [activeTab, setActiveTab] = useState("description");
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const PER_PAGE = 4;

  const { data: reviews = [], isPending } = useProductReviewsQuery(productId, {
    enabled: activeTab === "reviews",
  });

  useEffect(() => {
    setPage(1);
  }, [activeTab, productId]);

  const paginatedReviews = reviews.slice(
    (page - 1) * PER_PAGE,
    page * PER_PAGE
  );

  return (
    <section className={styles.tabsSection}>
      <div className={styles.tabsHeader}>
        <button
          className={`${styles.tabBtn} ${
            activeTab === "description" ? styles.activeTab : ""
          }`}
          onClick={() => setActiveTab("description")}
        >
          DESCRIPTION
        </button>

        <button
          className={`${styles.tabBtn} ${
            activeTab === "reviews" ? styles.activeTab : ""
          }`}
          onClick={() => setActiveTab("reviews")}
        >
          REVIEWS ({reviews.length})
        </button>
      </div>

      <div className={styles.tabContent}>
        {activeTab === "description" && (
          <>
            <HeadingTitle text="Product Description" style={styles.heading} />
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html: productDescription || "",
              }}
            />
          </>
        )}

        {activeTab === "reviews" && (
          <>
            <div className={styles.reviewHeader}>
              <HeadingTitle
                text={`Reviews (${reviews.length})`}
                style={styles.heading}
              />
            </div>

            {isPending ? (
              <Loader title="Loading reviews..." />
            ) : reviews?.length === 0 ? (
              <p className={styles.emptyText}>
                No reviews yet. Be the first one!
              </p>
            ) : (
              <>
                <ul className={styles.reviewList}>
                  {paginatedReviews?.map((item) => {
                    const isOwner =
                      String(item?.user_id) === String(loggedInUserId);

                    const userName = item?.user?.username || "";

                    return (
                      <li key={item.id} className={styles.reviewCard}>
                        <div className={styles.reviewTop}>
                          <div className={styles.userInfo}>
                          <div className={styles.avatar}>
  {item?.user?.profile_image ? (
    <Image
      src={item.user.profile_image}
      alt={userName || "User"}
      className={styles.userLogo}
    />
  ) : (
    <span className={styles.avatarFallback}>
      {userName ? userName.charAt(0).toUpperCase() : "U"}
    </span>
  )}
</div>

                            <div>
                              <SubHeadingTitle
                                style={styles.userName}
                                subTitle={userName}
                              />

                              <p className={styles.reviewDate}>
                                {new Date(item.created_at).toLocaleDateString(
                                  "en-IN",
                                  {
                                    day: "numeric",
                                    month: "short",
                                    year: "numeric",
                                  }
                                )}
                              </p>

                              <SubHeadingTitle
                                style={styles.reviewTitle}
                                subTitle={item.review}
                              />
                            </div>
                          </div>

                          <Ratings rating={item.rating} />

                          {isOwner && (
                            <Button
                              title="Edit Review"
                              style={styles.writeReviewBtn}
                              onHandler={() =>
                                navigate(`/review/edit/${item.id}`, {
                                  state: {
                                    productId,
                                    vendorId: item.vendor_id,
                                    reviewText: item.review,
                                    rating: item.rating,
                                  },
                                })
                              }
                            />
                          )}
                        </div>
                      </li>
                    );
                  })}
                </ul>

                {reviews?.length > PER_PAGE && (
                  <div className={styles.paginationWrapper}>
                    <Pagination
                      currentPage={page}
                      total={reviews?.length}
                      per_page={PER_PAGE}
                      handlePageChange={setPage}
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default ReviewTabs;
